import React, { useState } from "react";
import '../css/Afficher_Horaires.css'

const formatOpeningHours = (horaires) => {
  const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

  const formattedHours = days.map((day) => ({ day, slots: [] }));

  const horairesByDay = horaires.reduce((acc, { jour, ouverture, fermeture }) => {
    const dayIndex = jour === 0 ? 6 : jour - 1;
    if (!acc[dayIndex]) acc[dayIndex] = [];
    acc[dayIndex].push({ ouverture, fermeture });
    return acc;
  }, {});

  Object.entries(horairesByDay).forEach(([index, slots]) => {
    formattedHours[index].slots = slots;
  });

  return formattedHours;
};

const isCurrentlyOpen = (horaires) => {
  const now = new Date();
  const currentDay = now.getDay(); 
  const currentTime = now.getHours() * 100 + now.getMinutes(); 

  const todaySlots = horaires.filter(({ jour }) => jour === currentDay);

  for (const { ouverture, fermeture } of todaySlots) {
    const openingTime = parseInt(ouverture.slice(0, 2) + ouverture.slice(3, 5), 10);
    const closingTime = parseInt(fermeture.slice(0, 2) + fermeture.slice(3, 5), 10);

    if (currentTime >= openingTime && currentTime <= closingTime) {
      return true; 
    }
  }

  return false; 
};
export const ES_Horaires_Ouverture = ({ horaires , scrollDownDemanded, setScrollDownDemanded}) => {
  const [isOpen, setIsOpen] = useState(false);
  const formattedHours = formatOpeningHours(horaires);
  const isOpenNow = isCurrentlyOpen(horaires);
  
  const currentDayIndex = (new Date().getDay() + 6) % 7; 

  const toggleOpen = () => {
    setIsOpen(!isOpen);
    setScrollDownDemanded(!scrollDownDemanded);
  };

  return (
    <div>
      <div className="opening-hours-header">
        <button 
          onClick={toggleOpen} 
          className="opening-hours-button"
          style={{ display: 'flex', fontFamily: "Arial, sans-serif", fontWeight: 'bold', flexDirection: 'row' }}
        >
          <img src={isOpen ? "chevron-bas.png" : "chevron-droit.png"} style={{ height: '15px', width: '15px', marginRight: '20%' }} />
          Horaires
        </button>
        <div className="status-indicator">
          <span 
            className="status-circle"
            style={{ backgroundColor: isOpenNow ? "green" : "red" }}
          />
          <span>{isOpenNow ? "Ouvert actuellement" : "Fermé actuellement"}</span>
        </div>
      </div>
      {isOpen && (
        <ul className="opening-hours-list">
          {formattedHours.map(({ day, slots }, index) => {
            const isToday = index === currentDayIndex;

            return (
              <li 
                key={day} 
                className="opening-hours-item" 
                style={{ fontWeight: isToday ? 'bold' : 'normal' }} 
              >
                <span className="day">{day}:</span>
                {slots.length > 0 ? (
                  <ul className="slots-list">
                    {slots.map(({ ouverture, fermeture }, idx) => (
                      <li 
                        key={idx} 
                        className="slot"
                        style={{ fontWeight: isToday ? 'bold' : 'normal' }} 
                      >
                        {ouverture.slice(0, 5)} - {fermeture.slice(0, 5)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="closed" style={{ fontWeight: isToday ? 'bold' : 'normal' }} >Fermé</span>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
